<form
  class="otd-sale-modal"
  [class.otd-sale-modal--hidden]="saleFailed"
  [formGroup]="form"
  (ngSubmit)="$event.preventDefault()"
>
  <header class="otd-sale-modal__header">
    <div>
      <p class="otd-sale-modal__title">{{ title }}</p>
      <p class="otd-sale-modal__lead">Ingresa los datos de la transferencia que confirmó Tesorería.</p>
    </div>
    <button type="button" class="otd-sale-modal__close" aria-label="Cerrar" (click)="close()">
      <span class="icon-close icon-size-m u-icon"></span>
    </button>
  </header>

  <div class="otd-sale-modal__body">
    <div class="otd-sale-modal__grid">
      <app-select class="otd-sale-modal__fund" formControlName="fund" label="Fondo *" [options]="funds"></app-select>

      <div class="otd-sale-modal__field">
        <app-input formControlName="fundTea" label="TEA del fondo (%) *" type="number"></app-input>
        <span class="otd-sale-modal__error otd-sale-modal__tea-error" *ngIf="isTeaAboveMaximum"
          >El valor debe ser menor o igual a {{ maximumFundTea }}%</span
        >
      </div>

      <div class="otd-sale-modal__field">
        <app-date-picker
          class="otd-sale-modal__finalize-date"
          formControlName="finalizeDate"
          label="Fecha de finalización de inversiones *"
          [dateFilter]="isFinalizeDateSelectable"
        ></app-date-picker>
        <span class="otd-sale-modal__error otd-sale-modal__finalize-date-error" *ngIf="isFinalizeDateAfterSaleDate"
          >La fecha no puede ser posterior a la fecha de la venta</span
        >
        <p class="otd-sale-modal__hint">Los inversionistas salen con su capital y su retorno a esta fecha.</p>
      </div>

      <div class="otd-sale-modal__field">
        <app-date-picker
          class="otd-sale-modal__sale-date"
          formControlName="saleDate"
          label="Fecha de la venta *"
          [dateFilter]="isSaleDateSelectable"
        ></app-date-picker>
        <p class="otd-sale-modal__hint">
          Igual o posterior a la finalización. Con esta fecha se calculan los días restantes y la comisión.
        </p>
      </div>
    </div>

    <div class="otd-sale-modal__field otd-sale-modal__transaction-field">
      <div class="otd-sale-modal__transaction-id">
        <app-input
          formControlName="transactionIdInput"
          label="ID de la transacción bancaria *"
          placeholder="Ej. 0012345"
        ></app-input>
        <lib-ui-button variant="outline" size="s" label="Agregar" (onClick)="addTransactionId()"></lib-ui-button>
      </div>
      <span class="otd-sale-modal__error otd-sale-modal__transaction-id-error" *ngIf="isTransactionIdTooLong"
        >El número de operación debe tener máximo 7 dígitos</span
      >
      <div class="otd-sale-modal__transaction-ids" *ngIf="transactionIds.length">
        <app-chip
          *ngFor="let transactionId of transactionIds.controls; let index = index"
          [content]="transactionId.value"
          (dismissChip)="removeTransactionId(index)"
        ></app-chip>
      </div>
      <p class="otd-sale-modal__hint">
        Te lo pasa Tesorería por Slack. Si el fondo pagó en varias transferencias, agrega cada ID.
      </p>
    </div>

    <div class="otd-sale-modal__field otd-sale-modal__voucher-field">
      <span class="otd-sale-modal__label">Comprobante (opcional)</span>
      <lib-file-upload
        class="otd-sale-modal__voucher"
        formControlName="voucher"
        formats="image+pdf"
        [getFileName]="true"
        initialLabel="Elige un archivo. PDF o imagen, hasta 5 MB."
        loadedLabel="Voucher cargado"
      ></lib-file-upload>
    </div>

    <section class="otd-sale-modal__detail" *ngIf="detail">
      <p class="otd-sale-modal__section-title">Detalle por factura</p>
      <table class="otd-sale-modal__table">
        <thead>
          <tr>
            <th>Factura</th>
            <th class="otd-sale-modal__number">Días restantes</th>
            <th class="otd-sale-modal__number">Comisión del fondo</th>
            <th class="otd-sale-modal__number">A transferir</th>
          </tr>
        </thead>
        <tbody>
          <tr class="otd-sale-modal__operation" *ngFor="let operation of detail.operations">
            <td>
              <p>{{ operationCode(operation) }}</p>
              <p class="otd-sale-modal__secondary" *ngIf="operation.partitionsCount > 1">
                {{ operation.partitionsCount }} particiones
              </p>
              <p class="otd-sale-modal__secondary otd-sale-modal__finsmart-return" *ngIf="operation.finsmartReturn">
                Retorno Finsmart {{ formatAmount(operation.finsmartReturn) }}
              </p>
            </td>
            <td class="otd-sale-modal__number">{{ operation.remainingDays }}</td>
            <td class="otd-sale-modal__number">{{ formatAmount(operation.fundCommission) }}</td>
            <td class="otd-sale-modal__number">{{ formatAmount(operation.transferAmount) }}</td>
          </tr>
        </tbody>
      </table>

      <dl class="otd-sale-modal__summary">
        <div class="otd-sale-modal__summary-row">
          <dt>Monto neto</dt>
          <dd>{{ formatAmount(detail.totals.netAmount) }}</dd>
        </div>
        <div class="otd-sale-modal__summary-row">
          <dt>Comisión del fondo</dt>
          <dd>{{ formatAmount(detail.totals.fundCommission) }}</dd>
        </div>
        <div class="otd-sale-modal__summary-row otd-sale-modal__summary-row--strong">
          <dt>El fondo transfiere</dt>
          <dd>{{ formatAmount(detail.totals.transferAmount) }}</dd>
        </div>
        <div class="otd-sale-modal__summary-row" *ngIf="detail.totals.finsmartReturn">
          <dt>Retorno de Finsmart</dt>
          <dd class="otd-sale-modal__finsmart-return">{{ formatAmount(detail.totals.finsmartReturn) }}</dd>
        </div>
      </dl>
    </section>

    <app-section-message
      class="otd-sale-modal__notice"
      *ngIf="closingNotice"
      type="informative"
      [text]="closingNotice"
    ></app-section-message>
  </div>

  <footer class="otd-sale-modal__footer">
    <div class="otd-sale-modal__transfer" *ngIf="detail">
      <p class="otd-sale-modal__transfer-label">El fondo transfiere</p>
      <p class="otd-sale-modal__transfer-amount">{{ formatAmount(detail.totals.transferAmount) }}</p>
    </div>
    <div class="otd-sale-modal__actions">
      <lib-ui-button variant="outline" size="m" label="Volver a la lista" (onClick)="close()"></lib-ui-button>
      <lib-ui-button
        class="otd-sale-modal__confirm"
        variant="filled"
        size="m"
        label="Confirmar venta"
        [isDisabled]="!canConfirm"
        (onClick)="confirmSale()"
      ></lib-ui-button>
    </div>
  </footer>
</form>

<section class="otd-sale-modal__failure" *ngIf="saleFailed">
  <img class="otd-sale-modal__failure-icon" src="assets/icons/link_off_black.svg" alt="" />
  <p class="otd-sale-modal__failure-text">Algo salió mal...</p>
  <lib-ui-button
    class="otd-sale-modal__failure-return"
    variant="outline"
    size="m"
    label="Regresar"
    (onClick)="returnToSale()"
  ></lib-ui-button>
</section>
